export default class GameSoundVars {
    public static "IDLE_MUSIC" = "idleBackgroundMusic";
    public static "SEAGULLS" = "seagulls";
    public static "PARROTS" = "parrots";
    public static "BIG_WIN_END" = "big_win_end_tune";

    public static "WIN_SIMPLE" = "win_simple";
    public static "WIN_SMALL" = "win_small";
    public static "WIN_MEDIUM" = "win_medium";
    public static "WIN_MEGA" = "win_mega";
    public static "BIG_WIN" = "big_win";
    public static "BIG_WIN_COUNTER_END" = "big_win_counter_end";
    public static "JP_SMALL" = "jp_small";
    public static "JP_BIG" = "jp_big";
}
